import type { ITransaction } from '../../../private/db/interface';
import type { IDBVersionMigrator } from './interface';
import Schema from './schema';

const VERSION = 6;

const module: IDBVersionMigrator = {
    version: VERSION,
    description: 'ISiteObjectOnFloorPlanDto composite PK update (part 2)',
    mappingsChanges: Schema(VERSION),
    upgrade: async (transaction: ITransaction) => {
        const tableOld = transaction.table('ISiteObjectOnFloorPlanDto_tmp');
        const tableNew = transaction.table('ISiteObjectOnFloorPlanDto');
        const collection = tableOld.toCollection();
        const keys = await collection.keys();
        const items = await collection.toArray();

        await tableNew.bulkAdd(items);
        await tableOld.bulkDelete(keys);
    },
};

export default Object.freeze(module);
